import React from 'react';
import { InstructionFormDetails } from '../../commonAfterFormPage/InstructionFormDetails';
import { NormalText } from '../../Styles';

export const PingPongCADTwentyFormDetails: InstructionFormDetails = {
  instructionsSubTitle: 'supplierValidation.afterRegister.pingPongCADTwenty.nowYouAreRegistered',
  paymentInstructionsTitle: 'supplierValidation.afterRegister.paymentInst',
  paymentInstructionsLines: [
    {
      description: 'supplierValidation.afterRegister.beneficiaryName',
      value: 'nsKnox Technologies, Inc',
    },
    {
      description: 'supplierValidation.afterRegister.address',
      value: '135 Madison Ave, New York, NY 10016',
    },
    {
      description: 'supplierValidation.afterRegister.checkingAccount',
      value: '466007904549',
    },
    {
      description: 'ABA Fedwire',
      value: '026009593',
    },
    {
      description: 'supplierValidation.afterRegister.swift',
      value: 'supplierValidation.afterRegister.bofaWire.swiftValues',
    },
  ],
  paymentInstructionsAddress: {
    description: 'supplierValidation.afterRegister.bankAndAddress',
    value: (
      <NormalText>
        Bank of America,
        <br />
        222 Broadway,
        <br />
        New York, NY 10038
      </NormalText>
    ),
  },
  currencies: [],
  pleaseNote: {
    hideInvoice: true,
    pleaseNoteItem: ['supplierValidation.afterRegister.pingPongCADTwenty.pleaseNote'],
  },
  showWireTransferWarningBox: {
    achWireTransfer: true,
    swiftWireTransfer: false,
  },
  extraInstructions: [
    'supplierValidation.afterRegister.pingPongCADTwenty.step1',
    'supplierValidation.afterRegister.pingPongCADTwenty.step2',
  ],
};
